import { styled } from '@mui/system'

export const TermsWrapper = styled('div')`
    margin-top: 8px;
`
